import React, {useState} from 'react';
import {FormModal} from 'components/modals';
import StoryboardSharingForm from './StoryboardSharingForm';
import StoryboardUserAccessTable from './StoryboardUserAccessTable';
import {withTranslation, WithTranslation} from 'react-i18next';
import i18n from 'i18n';

interface ModalProps {
    show: boolean;
    onHide: () => void;
}

interface StoryboardData {
    title: string;
    id: number;
}

interface StoryboardSharingModalProps extends WithTranslation {
    modalProps: ModalProps;
    storyboardData: StoryboardData;
}

const StoryboardSharingModal: React.FC<StoryboardSharingModalProps> = ({modalProps, storyboardData}) => {
    const [formKey, setFormKey] = useState<number>(Math.random());

    const resetForm = (): void => {
        setFormKey(Math.random());
    };

    return (
        <FormModal
            isOpen={modalProps.show}
            onClose={modalProps.onHide}
            title={
                <div>
                    <p>{i18n.t('jt_share_the_storyboard.text')}</p>
                    <p className="h6">
                        {storyboardData.title}
                    </p>
                </div>
            }
        >
            <h5>{i18n.t('jt_give_access.text')}</h5>
            <StoryboardSharingForm
                key={formKey}
                storyboardId={storyboardData.id}
                onFinish={resetForm}
            />

            <h5 className="mt-3">{i18n.t('jt_edit_access.text')}</h5>
            <StoryboardUserAccessTable
                storyboardId={storyboardData.id}
            />
        </FormModal>
    );
};

export default withTranslation()(StoryboardSharingModal);